import shaka from "shaka-player";

export const canBrowserPlayVideo = (): boolean =>
  shaka.Player.isBrowserSupported();
